import { useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {Box,Button,TextField,CircularProgress, FormHelperText,} from '@mui/material';
import { useAuth } from 'src/hooks/useAuth';
import { useRefMounted } from 'src/hooks/useRefMounted';
import { signIn } from 'next-auth/react';
import { handleSignInWithEmailAndPassword } from 'src/utils/firebaseAuth';
import { useSnackbar } from 'notistack';

export const LoginFirebaseAuth = (props) => {
  
  const {signInWithEmailAndPassword }= useAuth();
  const isMountedRef = useRefMounted();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      submit: null
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(('El correo electrónico proporcionado debe ser una dirección de correo electrónico válida.'))
        .max(255)
        .required(('El campo de correo electrónico es obligatorio.')),
      password: Yup.string()
        .max(255)
        .required(('El campo de contraseña es obligatorio')),
    }),
    onSubmit: async (values, helpers) => {
      setIsSubmitting(true);
      const credential = await handleSignInWithEmailAndPassword(values.email, values.password);
      if(credential){
        const options = {
          email: credential.user?.email,
          uid: credential.user?.uid,
          callbackUrl: '/',
        };
        await signIn('credentials', options);
      } else {
        enqueueSnackbar('Credenciales incorrectas', {
          variant: 'error',
        });
      }
      setIsSubmitting(false);
    }
  });

  return (
    <Box {...props}>
      <form noValidate onSubmit={formik.handleSubmit}>
        <TextField
          error={Boolean(formik.touched.email && formik.errors.email)}
          fullWidth
          helperText={formik.touched.email && formik.errors.email}
          label={'Correo electrónico'}
          placeholder={'Su dirección de correo electrónico aquí...'}
          margin="normal"
          name="email"
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          type="email"
          value={formik.values.email}
          variant="outlined"
        />
        <TextField
          error={Boolean(formik.touched.password && formik.errors.password)}
          fullWidth
          helperText={formik.touched.password && formik.errors.password}
          label={'Contraseña'}
          placeholder={'Tu contraseña aquí...'}
          margin="normal"
          name="password"
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          type="password"
          value={formik.values.password}
          variant="outlined"
        />
        <Box
          alignItems="center"
          display={{ xs: 'block', md: 'flex' }}
          justifyContent="space-between"
        >
        </Box>
        {formik.errors.submit && (
          <FormHelperText error>{formik.errors.submit}</FormHelperText>
        )}
        <Button
          sx={{
            mt: 3
          }}
          color="primary"
          startIcon={
            formik.isSubmitting ? <CircularProgress size="1rem" /> : null
          }
          disabled={formik.isSubmitting || isSubmitting}
          size="large"
          fullWidth
          type="submit"
          variant="contained"
        >
          Iniciar sesion
        </Button> 
        <Button 
          sx={{
            mt: 3
          }}
          color="primary"
          size="large"
          fullWidth
          href='/auth/recover-password'
        >
          ¿Olvidaste tu contraseña?
        </Button>
        </form>
    </Box>
  );
};
